import type { Option } from '@openx/types/options';
import {
  type ContentObjectOption,
  ContentObjectOptions,
  type ContentObjectProps,
} from '@openx/types/targeting/contentObject';
import { noop } from '@openx/utils/noop';
import { useCallback } from 'react';
import { FiltersTitle } from '../../../shared/FiltersTitle/FiltersTitle';
import { SelectedItems } from '../../../shared/SelectedItems/SelectedItems';
import type { TargetingItemsProps } from '../../../types';
import { itemTitle } from '../../constants';

export const DefaultItems = ({
  targetingParams,
  type,
  readonly,
  disabledReasonMessage,
  onChange = noop,
}: TargetingItemsProps<ContentObjectProps> & { type: ContentObjectOption }) => {
  const handleChange = useCallback(() => {
    onChange(state => ({ ...state, [type]: null }));
  }, [onChange, type]);

  if (!targetingParams[type]) {
    return null;
  }

  const val = [targetingParams[type]] as Option[];

  return (
    <div data-test="sub-section">
      <FiltersTitle
        onClear={handleChange}
        title={itemTitle(type, val.length)}
        readonly={readonly}
        disabledReasonMessage={disabledReasonMessage}
      />

      <SelectedItems
        isAddIcon={type === ContentObjectOptions.LIVESTREAM || val[0]?.name === 'True'}
        selectedItems={[val[0]?.name]}
        readonly={readonly}
        handleChange={handleChange}
        dataTest={type}
      />
    </div>
  );
};
